import React from 'react';
import i18n from 'i18next';
import { useSelector } from '@xstate/react';

import { Currency, formatCurrency, formatDate } from '@chargify/formatters';
import PlanChangeSummaryCharges from '../../components/PlanChangeSummaryCharges';
import { ChangePlanInterpreter } from '../../machines/changePlan/types';
import { changePlanSelectors } from '../../machines/changePlan';

import { PlanChangeSummary } from '../../components/PlanChangeSummary';
import { PlanChangeAlerts } from '../../components';

type Props = {
  changePlanService: ChangePlanInterpreter;
  currency: Currency;
  currentProductName: string;
};

export const PreviewProductMigrationContainer = ({
  changePlanService,
  currency,
  currentProductName,
}: Props) => {
  const planPreview = useSelector(
    changePlanService,
    changePlanSelectors.getChangePlanPreview
  );
  const {
    productChangeStrategy,
    product,
    existingBalanceInCents,
    billingEndDate,
    totalInCents,
    proratedAdjustmentInCents,
  } = planPreview;
  const formatAmount = (amount: number): string =>
    formatCurrency(currency, amount, i18n.language);

  const nextBillingAmountInCents =
    product.priceInCents - existingBalanceInCents;

  const isNotDelayed = productChangeStrategy !== 'delayed';
  const basePlanPrice = formatAmount(product.priceInCents);
  const totalCharge = formatAmount(totalInCents > 0 ? totalInCents : 0);
  const nextBillingDate = formatDate(billingEndDate, i18n.language);
  const existingBalance = formatAmount(existingBalanceInCents);
  const nextBillingAmount = formatAmount(nextBillingAmountInCents);
  const proratedCreditAmount = formatAmount(proratedAdjustmentInCents);
  const creditBalance = formatAmount(
    totalInCents < 0 ? Math.abs(totalInCents) : 0
  );
  return (
    <div>
      <PlanChangeSummary
        currentProductName={currentProductName}
        productChangeStrategy={productChangeStrategy}
        productName={product.name}
        basePlanPrice={basePlanPrice}
        billingEndDate={formatDate(billingEndDate)}
        existingBalance={existingBalance}
        nextBillingAmount={nextBillingAmount}
        proratedCreditAmount={proratedCreditAmount}
      />
      {isNotDelayed ? (
        <PlanChangeSummaryCharges
          changePlanPreview={planPreview}
          currency={currency}
        />
      ) : null}
      <PlanChangeAlerts
        creditBalance={creditBalance}
        productChangeStrategy={productChangeStrategy}
        nextBillingDate={nextBillingDate}
        basePlanPrice={basePlanPrice}
        totalCharge={totalCharge}
      />
    </div>
  );
};
